






























































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";

import {
  SftpVendorTypeOption,
  UserPermission
} from "@/shared/types";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";
import { useNotifierStore } from "@/shared/store/notifier";
import { useFileProcessorSettingsStore } from "@/shared/store/fileProcessorSettings";

@Component
export default class EmployerSftpVendorType extends Vue {

  notifierStore = useNotifierStore();
  featureFlagStore = useFeatureFlagStore();
  rolePermissionsStore = useRolePermissionsStore();
  fileProcessorSettingsStore = useFileProcessorSettingsStore();

  @Prop() employerId: number;

  submitDisabled = false;
  mappingSubmitDisabled = false;

  sftpVendorTypeSelection: SftpVendorTypeOption = SftpVendorTypeOption.None;
  sftpMapCodeInput = "";

  sfptSettingSelectOptions: SftpVendorTypeOption[] = [
    SftpVendorTypeOption.None,
    SftpVendorTypeOption.Direct,
    SftpVendorTypeOption.Paylocity,
    SftpVendorTypeOption.Paycor,
    SftpVendorTypeOption.Trinity
  ];

  get hasEditPermission (): boolean {
    return this.featureFlagStore.flags.hsa4475allowRolePermissions
        ? this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalEmployerEdit)
        : true;
  }

  created () {
    this.fetchSftpVendorType();
  }

  mounted () {
    this.sftpVendorTypeSelection = this.sftpVendorTypeForEmployer;
  }

  get displaySftpMappingForm (): boolean {
    return (this.sftpVendorTypeForEmployer !== SftpVendorTypeOption.None)
        && (this.sftpVendorTypeForEmployer !== SftpVendorTypeOption.Direct);
  }

  @Watch("sftpVendorTypeForEmployer", { deep: true })
  onStoreValueChange (newValue) {
    this.sftpVendorTypeSelection = newValue;
  }

  get sftpVendorTypeForEmployer () {
    const storeValue = this.fileProcessorSettingsStore.getSftpVendorType(this.employerId);
    return storeValue ? storeValue : SftpVendorTypeOption.None;
  }

  get vendorMappingsForEmployer () {
    return this.fileProcessorSettingsStore.getSftpMappings(this.employerId);
  }

  @Watch("employerId")
  fetchSftpVendorType () {
    this.submitDisabled = false;
    this.fileProcessorSettingsStore.loadEmployerSftpVendorType(this.employerId);
  }

  updateSftpVendorType () {
    this.$validator.validateAll().then(isValid => {

      if (!isValid || this.submitDisabled || !this.fileProcessorSettingsStore.sftpVendorTypeLoaded) {
        return;
      }

      if (this.sftpVendorTypeForEmployer === this.sftpVendorTypeSelection) {
        return;
      }

      this.submitDisabled = true;
      const employerId = this.employerId;
      const sftpVendorType = this.sftpVendorTypeSelection;

      this.fileProcessorSettingsStore.updateEmployerSftpVendorType({ employerId, sftpVendorType })
          .then(() => {
            this.notifierStore.setSuccess("Saved");
          })
          .finally(() => this.submitDisabled = false);
    });
  }

  submitDeleteSftpMapping (sftpMapId: number) {
    this.$validator.validateAll().then(isValid => {

      if (!isValid || this.mappingSubmitDisabled || !this.fileProcessorSettingsStore.sftpVendorTypeLoaded) {
        return;
      }

      this.mappingSubmitDisabled = true;
      const employerId = this.employerId;

      this.fileProcessorSettingsStore.deleteSftpMapping({ employerId, sftpMapId })
          .then(() => {
            this.notifierStore.setSuccess("Saved");
          })
          .finally(() => this.mappingSubmitDisabled = false);
    });
  }

  submitAddSftpMapping () {
    this.$validator.validateAll().then(isValid => {

      if (!isValid || this.mappingSubmitDisabled || !this.fileProcessorSettingsStore.sftpVendorTypeLoaded ||
          !this.sftpMapCodeInput) {
        return;
      }

      this.mappingSubmitDisabled = true;
      const employerId = this.employerId;
      const sftpMapCode = this.sftpMapCodeInput;

      this.fileProcessorSettingsStore.beginAddSftpMapping({ employerId, sftpMapCode })
          .then(() => {
            this.notifierStore.setSuccess("Saved");
          })
          .finally(() => this.mappingSubmitDisabled = false);
    });
  }

}
